import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-powered-by-smooved',
    template: `
        <div class="u-bordered u-padding-top u-padding-right u-padding-left">
            <p class="u-margin-bottom-half">{{ 'POWERED_BY_SMOOVED.1' | translate }}</p>
            <p class="u-margin-bottom">{{ 'POWERED_BY_SMOOVED.2' | translate }}</p>
            <div class="u-flex-row u-flex-justify-content-flex-end">
                <img src="assets/images/hero.png" class="h-[113px]" />
            </div>
        </div>
    `,
    styleUrls: ['./powered-by-smooved.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoweredBySmoovedComponent {}
